<script setup lang="ts">
import { ref } from 'vue'
import './_index.scss'
import type { Props } from './types'
import AppCarrousel from '@/components/App/Carrousel/index.vue'

const props = defineProps<Props>()
const { t } = useI18n()
const currentAmenity = ref(0)
const carrouselImageSources = props.amenitiesData.map((object) => {
  const imageUrl = object.imageUrl
  return [
    {
      mediaWidth: 767,
      src: `${imageUrl}?auto=compress,enhance,format&w=1000`
    },
    {
      mediaWidth: 1023,
      src: `${imageUrl}?auto=compress,enhance,format&w=1200`
    },
    {
      mediaWidth: 2500,
      src: `${imageUrl}?auto=compress,enhance,format&w=2000`
    }
  ]
})
</script>

<script lang="ts">
export default {
  name: 'PdAmenitiesCarrousel'
}
</script>

<template>
  <section
    class="pd-amenities-carrousel">
    <h3 class="text-22 md:text-32 text-carbon-800 font-semibold mb-8 ml-24 lg:ml-0">
      {{ t('amenities.title') }}
    </h3>

    <p class="ml-24 lg:ml-0 mb-16 text-16 md:text-20 font-medium text-carbon-800">
      {{ amenitiesData[currentAmenity].title }}
    </p>

    <AppCarrousel
      id="amenities-carrusel"
      :pictures-sources="carrouselImageSources"
      class="w-full h-250 md:h-450 lg:h-[58.4rem]"
      anchor-styles="w-full absolute left-0 top-1/2 -translate-y-1/2"
      img-styles="h-full"
      picture-container-styles="rounded-0 md:rounded-md"
      :figure-styles="{ aspectRatio: '2/1' }"
      :image-multiplier="1"
      size-reverse
      zoom
      @image-scrolled="(index) => currentAmenity = index" />

    <div class="flex items-center justify-center">
      <p class="pd-amenities-carrousel__description text-12 font-normal text-carbon-300 mx-24 mt-16 md:text-center ml:m-auto0">
        {{ t('amenities.description') }}
      </p>
    </div>
  </section>
</template>

<i18n src="./i18n.json" lang="json" />
